var $ = require('jquery');

$(document).ready(function() {
    subscribeModal();
    alertModal();
})
$(window).on('load', function() {
    if ( $('.gform_confirmation_message').length ) {
        $('html, body').animate({
            scrollTop: $('.gform_confirmation_message').closest('.form').offset().top - 175,
        }, 1000);
    }
})
function subscribeModal() {
    $(document).on('click', 'a[href*="#subscribe"] ', function (e) {
        e.preventDefault();
        $('#subscribe-modal').show();
        $("body").addClass("-has-modal");

        var buttonHeight = $('#subscribe-modal').find('.modal__btn').outerHeight(true);
        var contentMaxHeight = 'calc(100% - ' + buttonHeight + 'px)';
        $('#subscribe-modal').find('.modal__form').css('max-height', contentMaxHeight);

        var initialHeight = $('#subscribe-modal').find('.modal__form').outerHeight(true);
        $('#subscribe-modal').find('.modal__form').css('height', initialHeight);
    });
    $(document).on('click', '.modal__btn', function (e) {
        $('#subscribe-modal').hide();
        $("body").removeClass("-has-modal");
    });
}
function alertModal() {
    $(document).on('click', '.alert-modal', function (e) {
        e.preventDefault();
        $('#alert-modal').show();
        $("body").addClass("-has-modal");

        var buttonHeight = $('#alert-modal').find('.modal__btn').outerHeight(true);
        var contentMaxHeight = 'calc(100% - ' + buttonHeight + 'px)';
        $('#alert-modal').find('.modal__form').css('max-height', contentMaxHeight);

        var initialHeight = $('#alert-modal').find('.modal__form').outerHeight(true);
        $('#alert-modal').find('.modal__form').css('height', initialHeight);
    });
    $(document).on('click', '.modal__btn', function (e) {
        $('#alert-modal').hide();
        $("body").removeClass("-has-modal");
    });
}
export function imageModal(link, caption) {
    $('#image-modal').show();
    $("body").addClass("-has-modal");

    $('#image-modal').find('.modal__content').html('');
    $('#image-modal').find('.modal__content').append('<img src="' + link + '"/>');
    $('#image-modal').find('.modal__content').append('<figcaption>' + caption + '</figcaption>');
    
    var buttonHeight = $('#image-modal').find('.modal__btn').outerHeight(true);
    var figcaptionHeight = $('#image-modal').find('figcaption').outerHeight(true);
    var contentMaxHeight = 'calc(100% - ' + buttonHeight + 'px)';
    var imageMaxHeight = 'calc(100% - ' + figcaptionHeight + 'px)';
    $('#image-modal').find('.modal__content').css('max-height', contentMaxHeight);
    $('#image-modal').find('.modal__content img').css('max-height', imageMaxHeight);

    $(document).on('click', '.modal__btn', function (e) {
        $('#image-modal').hide();
        $("body").removeClass("-has-modal");
    });
}